// extracted by mini-css-extract-plugin
var _1 = "Switcher_active__9c0c5";
var _2 = "Switcher_disabled__6bc7e";
var _3 = "Switcher_label__4224e";
var _4 = "Switcher_root__52f30";
var _5 = "Switcher_slider__8d1bd";
var _6 = "Switcher_switch__1ec45";
export { _1 as "active", _2 as "disabled", _3 as "label", _4 as "root", _5 as "slider", _6 as "switch" }
